import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/about/components/AboutContent.tsx");
